import React from 'react';
import { useNavigate } from 'react-router-dom';

const ButtonNew = ({ to}) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    navigate(to); // Navegar a la ruta proporcionada
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full sm:w-auto flex items-center justify-center rounded py-2 px-4 text-sm font-medium text-white bg-green-700 hover:bg-green-800 transition duration-200"
    >
      <span className="material-icons-outlined mr-2">add</span> Nuevo
    </button>
  );
};

export default ButtonNew;
